import NavBar from '../components/NavBar';
import Maps from '../components/Maps';
import Contact from '../components/Contact';
import petr_image from '../img/pf3.png'; // 3 none
import michal_image from '../img/mf2.png';
import { useTranslation } from 'react-i18next';

import ProductSeparator from '../components/ProductSeparator';

import tp from '../img/pf.png';
import tm from '../img/mf.png';
import tp1 from '../img/pf1.png';
import tm1 from '../img/mf1.png';
import tp2 from '../img/pf2.png';
import tm2 from '../img/mf2.png';
import tp3 from '../img/pf3.png';
import tm3 from '../img/mf3.png';
import tp4 from '../img/pf4.png';


export default function ContactPage() {
  const { t } = useTranslation();
  return (
        <div class="grid">

          <Maps/>
          <Contact name={t("company_contact")}         tel="+420 731 103 442" gsm="+420 606 078 828" mail="info@sefos.cz" inverse={true}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={petr_image}/>
          <Contact name="Ing. Michal Feilhauer, Ph.D." tel="+420 732 988 303" mail="feilhauer.m@sefos.cz" titul={t("boss_title")} img={michal_image} inverse={true}/>


         {/* <ProductSeparator name={t("pf/mf")}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={tp}/>
          <Contact name="Ing. Michal Feilhauer, Ph.D." tel="+420 732 988 303" mail="feilhauer.m@sefos.cz" titul={t("boss_title")} img={tm} inverse={true}/>

          <ProductSeparator name={t("pf1/mf1")}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={tp1}/>
          <Contact name="Ing. Michal Feilhauer, Ph.D." tel="+420 732 988 303" mail="feilhauer.m@sefos.cz" titul={t("boss_title")} img={tm1} inverse={true}/>

          <ProductSeparator name={t("pf2/mf2")}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={tp2}/>
          <Contact name="Ing. Michal Feilhauer, Ph.D." tel="+420 732 988 303" mail="feilhauer.m@sefos.cz" titul={t("boss_title")} img={tm2} inverse={true}/>

          <ProductSeparator name={t("pf3/mf3")}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={tp3}/>
          <Contact name="Ing. Michal Feilhauer, Ph.D." tel="+420 732 988 303" mail="feilhauer.m@sefos.cz" titul={t("boss_title")} img={tm3} inverse={true}/>

          <ProductSeparator name={t("pf4")}/>
          <Contact name="Ing. Petr Feilhauer"          tel="+420 606 078 828" mail="feilhauer.p@sefos.cz" titul={t("boss_title")} img={tp4}/>*/}


          <NavBar location="contact_us"/> {/*je až nakonci aby byl opravdu nad všemi elementy */}
        </div>
  )
}